var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tws-header-action',{staticClass:"header-action--login",on:{"click":_vm.doLogin},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('TeliaCoreIcon',{staticClass:"icon",attrs:{"name":"end_user_thin","size":"2.4rem"}})]},proxy:true},{key:"text",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('header.login-button'))+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }